import { render, staticRenderFns } from "./ClinicPageManageVideos.vue?vue&type=template&id=2660b40e"
import script from "./ClinicPageManageVideos.vue?vue&type=script&lang=js"
export * from "./ClinicPageManageVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports